import { render, staticRenderFns } from "./VaPageNotFound.vue?vue&type=template&id=fd8e43f6&"
import script from "./VaPageNotFound.vue?vue&type=script&lang=js&"
export * from "./VaPageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./VaPageNotFound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports